import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { listProducts, listBundles, listProductDeals, listBundleDeals } from '../../api/crmApi';

import { productsKeys, bundlesKeys } from './keys';

export const productsListOptions = (filters = {}) =>
	queryOptions({
		queryKey: productsKeys.list(filters),
		queryFn: async () => listProducts(filters),
		staleTime: STALE_TIMES.STANDARD,
	});

export function useProductsList(filters = {}) {
	return useQuery(productsListOptions(filters));
}

export const bundlesListOptions = (filters = {}) =>
	queryOptions({
		queryKey: bundlesKeys.list(filters),
		queryFn: async () => listBundles(filters),
		staleTime: STALE_TIMES.STANDARD,
	});

export function useBundlesList(filters = {}) {
	return useQuery(bundlesListOptions(filters));
}

export function useProductDeals(productId) {
	return useQuery({
		queryKey: productsKeys.deals(productId),
		queryFn: () => listProductDeals(productId),
		enabled: Boolean(productId),
		staleTime: STALE_TIMES.STANDARD,
	});
}

export function useBundleDeals(bundleId) {
	return useQuery({
		queryKey: bundlesKeys.deals(bundleId),
		queryFn: () => listBundleDeals(bundleId),
		enabled: Boolean(bundleId),
		staleTime: STALE_TIMES.STANDARD,
	});
}
